import Vue from "vue";
import * as types from "../mutation-types";

const state = {
  shipmentStatusDaysCount: null
};

const getters = {
  shipmentStatusDaysCount: (state) => state.shipmentStatusDaysCount
};

const actions = {
  setShipmentStatusDaysCount({ commit }, value) {
    commit(types.SET_SETTINGS, ["shipmentStatusDaysCount", value]);
  }
};

const mutations = {
  [types.SET_SETTINGS](state, [key, value]) {
    Vue.set(state, key, value);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/settings.js